// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod-vo.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  rnimuQUizConfig: {
    url: 'https://pkvkqt.rsmu.ru/api',
    webUrl: 'https://pkvkqt.rsmu.ru',
    escapeTabTimes: 2,
    sentryDsn: ''
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
